export enum CUSTOMER_TYPE_NAME {
  VIP = 'vip',
  NEW = 'new',
  REGULAR = 'regular',
  AT_RISK = 'at_risk',
  NORMAL = 'normal',
}
